import { Divider, DividerProps, makeStyles } from '@material-ui/core';
import React from 'react';

export type VerticalDividerProps = Omit<DividerProps, "orientation"> & {
}

export function VerticalDivider (props: VerticalDividerProps) {
    const cls = useStyles();

    return (
        <Divider className={cls.root} {...props} flexItem orientation="vertical" />
    )
}

const useStyles = makeStyles(theme => ({
    root: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1)
    }
}));